module.exports = __webpack_public_path__ + "img/face8.fb1ed8f1.png";